export default __webpack_public_path__ + "static/media/Rectangle 71.3cc72c06.svg";